"use strict";import{css as e}from"@spectrum-web-components/base";const t=e`
:host{--spectrum-illustrated-message-description-max-inline-size:var(
--spectrum-illustrated-message-maximum-width
);--spectrum-illustrated-message-heading-max-inline-size:var(
--spectrum-illustrated-message-maximum-width
);--spectrum-illustrated-message-title-to-heading:var(
--spectrum-spacing-400
);--spectrum-illustrated-message-heading-to-description:var(
--spectrum-spacing-75
);--spectrum-illustrated-message-illustration-color:var(
--spectrum-neutral-visual-color
);--spectrum-illustrated-message-illustration-accent-color:var(
--spectrum-accent-visual-color
);--spectrum-illustrated-message-title-font-family:var(
--spectrum-sans-font-family-stack
);--spectrum-illustrated-message-title-font-weight:var(
--spectrum-heading-sans-serif-font-weight
);--spectrum-illustrated-message-title-font-style:var(
--spectrum-heading-sans-serif-font-style
);--spectrum-illustrated-message-title-font-size:var(
--spectrum-illustrated-message-title-size
);--spectrum-illustrated-message-title-line-height:var(
--spectrum-heading-line-height
);--spectrum-illustrated-message-title-color:var(--spectrum-heading-color);--spectrum-illustrated-message-description-font-family:var(
--spectrum-sans-font-family-stack
);--spectrum-illustrated-message-description-font-weight:var(
--spectrum-body-sans-serif-font-weight
);--spectrum-illustrated-message-description-font-style:var(
--spectrum-body-sans-serif-font-style
);--spectrum-illustrated-message-description-font-size:var(
--spectrum-illustrated-message-body-size
);--spectrum-illustrated-message-description-line-height:var(
--spectrum-body-line-height
);--spectrum-illustrated-message-description-color:var(
--spectrum-body-color
)}:host:lang(ja),:host:lang(ko),:host:lang(zh){--spectrum-illustrated-message-title-font-size:var(
--spectrum-illustrated-message-cjk-title-size
)}@media (forced-colors:active){:host{--highcontrast-illustrated-message-illustration-color:CanvasText;--highcontrast-illustrated-message-illustration-accent-color:Highlight}}:host{align-items:center;block-size:100%;display:var(--mod-illustrated-message-display,flex);flex-direction:column;justify-content:center;max-inline-size:var(--mod-illustrated-message-content-maximum-width);pointer-events:var(--mod-illustrated-message-pointer-events);text-align:center}#illustration{fill:currentColor;stroke:currentColor;color:var(
--highcontrast-illustrated-message-illustration-color,var(
--mod-illustrated-message-illustration-color,var(--spectrum-illustrated-message-illustration-color)
)
);margin-block-end:var(
--mod-illustrated-message-title-to-heading,var(--spectrum-illustrated-message-title-to-heading)
)}.spectrum-IllustratedMessage-accent{fill:currentColor;stroke:currentColor;color:var(
--highcontrast-illustrated-message-illustration-accent-color,var(
--mod-illustrated-message-illustration-accent-color,var(--spectrum-illustrated-message-illustration-accent-color)
)
)}#heading{color:var(
--mod-illustrated-message-title-color,var(--spectrum-illustrated-message-title-color)
);font-family:var(
--mod-illustrated-message-title-font-family,var(--spectrum-illustrated-message-title-font-family)
);font-size:var(
--mod-illustrated-message-title-font-size,var(--spectrum-illustrated-message-title-font-size)
);font-style:var(
--mod-illustrated-message-title-font-style,var(--spectrum-illustrated-message-title-font-style)
);font-weight:var(
--mod-illustrated-message-title-font-weight,var(--spectrum-illustrated-message-title-font-weight)
);line-height:var(
--mod-illustrated-message-title-line-height,var(--spectrum-illustrated-message-title-line-height)
);margin-block-end:var(--mod-illustrated-message-heading-to-body,0);margin-block-start:0;max-inline-size:var(
--mod-illustrated-message-heading-max-inline-size,var(--spectrum-illustrated-message-heading-max-inline-size)
)}#description{color:var(
--mod-illustrated-message-description-color,var(--spectrum-illustrated-message-description-color)
);font-family:var(
--mod-illustrated-message-description-font-family,var(--spectrum-illustrated-message-description-font-family)
);font-size:var(
--mod-illustrated-message-description-font-size,var(--spectrum-illustrated-message-description-font-size)
);font-style:var(
--mod-illustrated-message-description-font-style,var(--spectrum-illustrated-message-description-font-style)
);font-weight:var(
--mod-illustrated-message-description-font-weight,var(--spectrum-illustrated-message-description-font-weight)
);line-height:var(
--mod-illustrated-message-description-line-height,var(--spectrum-illustrated-message-description-line-height)
);margin-block-end:0;margin-block-start:var(
--mod-illustrated-message-heading-to-description,var(--spectrum-illustrated-message-heading-to-description)
);max-inline-size:var(
--mod-illustrated-message-description-max-inline-size,var(--spectrum-illustrated-message-description-max-inline-size)
);pointer-events:var(--mod-illustrated-message-description-pointer-events);position:var(--mod-illustrated-message-description-position);z-index:var(--mod-illustrated-message-description-z-index)}::slotted(svg[viewBox]){width:100%}
`;export default t;
//# sourceMappingURL=illustrated-message.css.js.map
